import { useTranslation } from 'react-i18next';

import KPIChartCard from '../../components/controlling/KPIChartCard';
import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import IDSBCompletedLineChart from './charts/IDSBCompletedLineChart';
import ServiceHistoryRequestSubmittedCompletedLineChart from './charts/ServiceHistoryRequestSubmittedCompletedLineChart';
import ServiceRecordSubmittedCompletedLineChart from './charts/ServiceRecordSubmittedCompletedLineChart';
import WorkshopRegisteredActivatedLineChart from './charts/WorkshopRegisteredActivatedLineChart';
import WorkshopStatusLineChart from './charts/WorkshopStatusLineChart';

const ControllingChartOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:controlling.meta.title')} />

      <KPIChartCard
        kpis={['w_registered', 'w_activated']}
        header={t('controlling:charts.workshop.activated_vs_registered.header')}
        description={t('controlling:charts.workshop.activated_vs_registered.description')}
        queryKey={'wp-registered-wp-activated'}
        chart={WorkshopRegisteredActivatedLineChart}
      />
      <KPIChartCard
        kpis={['w_pre_registered_absolute', 'w_registered_absolute', 'w_verified_absolute', 'w_activated_absolute']}
        header={t('controlling:charts.workshop.status.header')}
        description={t('controlling:charts.workshop.status.description')}
        queryKey={'w-status'}
        chart={WorkshopStatusLineChart}
      />
      <KPIChartCard
        kpis={['sr_excl_idsb_submitted', 'sr_excl_idsb_completed']}
        header={t('controlling:charts.service_record.submitted_vs_completed.header')}
        description={t('controlling:charts.service_record.submitted_vs_completed.description')}
        queryKey={'sr-submitted-sr-completed'}
        chart={ServiceRecordSubmittedCompletedLineChart}
      />
      <KPIChartCard
        kpis={['sr_idsb_submitted', 'sr_idsb_completed']}
        header={t('controlling:charts.idsb.completed.header')}
        description={t('controlling:charts.idsb.completed.description')}
        queryKey={'idsb-completed'}
        chart={IDSBCompletedLineChart}
      />
      <KPIChartCard
        kpis={['shr_submitted', 'shr_completed']}
        header={t('controlling:charts.service_history_request.submitted_vs_completed.header')}
        description={t('controlling:charts.service_history_request.submitted_vs_completed.description')}
        queryKey={'shr-submitted-shr-completed'}
        chart={ServiceHistoryRequestSubmittedCompletedLineChart}
      />
    </ContentLayout>
  );
};

export default ControllingChartOverviewPage;
